(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[18201],{

/***/ 61570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var ClutchWidget = function(param) {
    var _isLight = param.isLight, isLight = _isLight === void 0 ? false : _isLight;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isScriptLoaded = ref[0], setIsScriptLoaded = ref[1];
    var widgetRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var existingScript = document.querySelector('script[src="https://widget.clutch.co/static/js/widget.js"]');
        if (existingScript) return;
        var script = document.createElement("script");
        script.src = "https://widget.clutch.co/static/js/widget.js";
        script.async = true;
        script.onload = function() {
            setIsScriptLoaded(true);
        };
        document.body.appendChild(script);
        return function() {
            document.body.removeChild(script);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isScriptLoaded || !widgetRef.current) return;
        if (isLight) {
            widgetRef.current.removeAttribute("data-darkbg");
        } else {
            widgetRef.current.setAttribute("data-darkbg", "darkbg");
        }
        if (window.CLUTCHCO) {
            window.CLUTCHCO.Init();
        }
    }, [
        isLight,
        isScriptLoaded
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: widgetRef,
        className: "clutch-widget",
        "data-url": "https://widget.clutch.co",
        "data-widget-type": "1",
        "data-height": "40",
        "data-nofollow": "true",
        "data-expandifr": "true",
        "data-clutchcompany-id": "381822",
        "data-darkbg": isLight ? "" : "darkbg"
    }, isLight ? "clutch-light" : "clutch-dark");
};
/* harmony default export */ __webpack_exports__["Z"] = (ClutchWidget);


/***/ }),

/***/ 45783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ getContentfulImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);


var getContentfulImage = function(_param) {
    var src = _param.src, width = _param.width, quality = _param.quality, progressive = _param.progressive, format = _param.format, transparent = _param.transparent, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "src",
        "width",
        "quality",
        "progressive",
        "format",
        "transparent"
    ]);
    try {
        var url = new URL(src);
        var fm = format || (transparent ? "webp" : "jpg");
        if (!format && src.includes(".svg")) {
            fm = null;
        }
        if (fm === "jpg") {
            fm = "webp";
        }
        fm && url.searchParams.set("fm", fm);
        width && url.searchParams.set("w", width);
        quality && url.searchParams.set("q", quality);
        Object.entries(params).forEach(function(param) {
            var _$_param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _$_param[0], value = _$_param[1];
            return key && value && url.searchParams.set(key, value);
        });
        return url.href;
    } catch (e) {
        return src;
    }
};


/***/ }),

/***/ 18201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Header_SmallDropDownMenu; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Svg/index.jsx
var Svg = __webpack_require__(6778);
// EXTERNAL MODULE: ./components/Common/LinkWrapper/index.jsx + 1 modules
var LinkWrapper = __webpack_require__(40659);
// EXTERNAL MODULE: ./UI/sections/Header/SmallDropDownMenu/AITransformationMenu/styles.module.scss
var styles_module = __webpack_require__(55098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./UI/sections/Header/SmallDropDownMenu/NavItem/styles.module.scss
var NavItem_styles_module = __webpack_require__(56060);
var NavItem_styles_module_default = /*#__PURE__*/__webpack_require__.n(NavItem_styles_module);
;// CONCATENATED MODULE: ./UI/sections/Header/SmallDropDownMenu/NavItem/index.jsx





var NavItem = function(param) {
    var icon = param.icon, title = param.title, description = param.description, path = param.path, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkWrapper/* default */.Z, {
        isLocalLink: true,
        path: path,
        className: classnames_default()((NavItem_styles_module_default()).navItem, className),
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                type: icon,
                className: (NavItem_styles_module_default()).icons,
                id: "icon-".concat(icon)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (NavItem_styles_module_default()).title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (NavItem_styles_module_default()).description,
                        children: description
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./UI/sections/Header/utils/headerConstants.js
var headerConstants = __webpack_require__(75456);
;// CONCATENATED MODULE: ./UI/sections/Header/SmallDropDownMenu/AITransformationMenu/index.jsx











var AITransformationMenu = function(param) {
    var isLightTheme = param.isLightTheme, isPageScrolledDown = param.isPageScrolledDown;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((styles_module_default()).dropdownContainer, (0,_define_property/* default */.Z)({}, (styles_module_default()).light, isLightTheme || isPageScrolledDown)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).contentContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).leftContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Our AI Team"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).teamList,
                            children: headerConstants/* TEAM.map */.FV.map(function(param) {
                                var name = param.name, image = param.image, path = param.path;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                    path: path,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (styles_module_default()).memberContainer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (styles_module_default()).personImageContainer,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: (0,helpers/* getContentfulImage */.t)({
                                                        src: image,
                                                        format: "webp",
                                                        width: 200
                                                    }),
                                                    width: 132,
                                                    height: 132,
                                                    lazyBoundary: "700px",
                                                    unoptimized: true,
                                                    loader: function(args) {
                                                        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({}, args));
                                                    },
                                                    className: (styles_module_default()).memberImage
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: name
                                            })
                                        ]
                                    })
                                });
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Technolody Stack"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).techList,
                            children: headerConstants/* TECH_STACK.map */.y.map(function(icon) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).techImage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                        type: icon,
                                        id: "icon-".concat(icon)
                                    })
                                });
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).ourWorkContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Our Clients"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).clientsList,
                            children: headerConstants/* CLIENTS_LIST.map */.jV.map(function(param) {
                                var icon = param.icon, path = param.path, title = param.title;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                    path: path,
                                    className: (styles_module_default()).clientImage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (styles_module_default()).clientContainer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (styles_module_default()).clientIconContainer,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                                    type: icon
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: title
                                            })
                                        ]
                                    })
                                });
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Featured Cases"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).linksContainer,
                                children: headerConstants/* FEATURED_CASES.map */.z2.map(function(param) {
                                    var title = param.title, path = param.path;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                        title: title,
                                        path: path
                                    });
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var SmallDropDownMenu_AITransformationMenu = (AITransformationMenu);

// EXTERNAL MODULE: ./UI/components/ClutchWidget/index.jsx
var ClutchWidget = __webpack_require__(61570);
// EXTERNAL MODULE: ./utils/routes.js
var routes = __webpack_require__(27727);
// EXTERNAL MODULE: ./UI/sections/Header/SmallDropDownMenu/ServiceMenu/styles.module.scss
var ServiceMenu_styles_module = __webpack_require__(75754);
var ServiceMenu_styles_module_default = /*#__PURE__*/__webpack_require__.n(ServiceMenu_styles_module);
;// CONCATENATED MODULE: ./UI/sections/Header/SmallDropDownMenu/ServiceMenu/index.jsx










var ServiceMenu = function(param) {
    var isLightTheme = param.isLightTheme, isPageScrolledDown = param.isPageScrolledDown;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ServiceMenu_styles_module_default()).dropdownContainer, (0,_define_property/* default */.Z)({}, (ServiceMenu_styles_module_default()).light, isLightTheme || isPageScrolledDown)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ServiceMenu_styles_module_default()).contentContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ServiceMenu_styles_module_default()).leftContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (ServiceMenu_styles_module_default()).serviceTitle,
                            children: "We deliver services that drive your business growth"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ServiceMenu_styles_module_default()).clutchContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Read our Clutch reviews"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ClutchWidget/* default */.Z, {
                                    isLight: isLightTheme || isPageScrolledDown
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                            isLocalLink: true,
                            path: routes/* routes.services.path */._.services.path,
                            className: (ServiceMenu_styles_module_default()).seeAllButton,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "See All Services"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ServiceMenu_styles_module_default()).ourWorkContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ServiceMenu_styles_module_default()).linksContainer,
                            children: headerConstants/* SERVICES.map */.AU.map(function(param) {
                                var icon = param.icon, title = param.title, path = param.path;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                    title: title,
                                    icon: icon,
                                    path: path
                                });
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ServiceMenu_styles_module_default()).linksContainer,
                            children: headerConstants/* SERVICES_FULL.map */.oj.map(function(param) {
                                var icon = param.icon, title = param.title, path = param.path;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                    title: title,
                                    icon: icon,
                                    path: path
                                });
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SmallDropDownMenu_ServiceMenu = (ServiceMenu);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./UI/sections/Header/SmallDropDownMenu/WorksMenu/styles.module.scss
var WorksMenu_styles_module = __webpack_require__(42991);
var WorksMenu_styles_module_default = /*#__PURE__*/__webpack_require__.n(WorksMenu_styles_module);
;// CONCATENATED MODULE: ./UI/sections/Header/SmallDropDownMenu/WorksMenu/index.jsx












var WorksMenu = function(param) {
    var isLightTheme = param.isLightTheme, isPageScrolledDown = param.isPageScrolledDown;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((WorksMenu_styles_module_default()).dropdownContainer, (0,_define_property/* default */.Z)({}, (WorksMenu_styles_module_default()).light, isLightTheme || isPageScrolledDown)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (WorksMenu_styles_module_default()).contentContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (WorksMenu_styles_module_default()).leftContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Featured Cases"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (WorksMenu_styles_module_default()).teamList,
                            children: headerConstants/* FEATURED_CASES_PREVIEWS.map */.r_.map(function(param) {
                                var name = param.name, image = param.image, path = param.path;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                    isLocalLink: true,
                                    path: path,
                                    className: (WorksMenu_styles_module_default()).projectLink,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (WorksMenu_styles_module_default()).memberContainer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (WorksMenu_styles_module_default()).imageContainer,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: (0,helpers/* getContentfulImage */.t)({
                                                        src: image,
                                                        format: "webp",
                                                        width: 600
                                                    }),
                                                    width: 272,
                                                    height: 140,
                                                    lazyBoundary: "700px",
                                                    unoptimized: true,
                                                    loader: function(args) {
                                                        return (0,helpers/* getContentfulImage */.t)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, args), {
                                                            format: "webp",
                                                            width: 300
                                                        }));
                                                    },
                                                    className: (WorksMenu_styles_module_default()).memberImage
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: name
                                            })
                                        ]
                                    })
                                });
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                            isLocalLink: true,
                            path: routes/* routes.portfolio.path */._.portfolio.path,
                            className: (WorksMenu_styles_module_default()).seeAllButton,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "See All Cases"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (WorksMenu_styles_module_default()).ourWorkContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Other projects"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: headerConstants/* PROJECTS.map */.Fw.map(function(param) {
                                var title = param.title, description = param.description, path = param.path;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                    title: title,
                                    description: description,
                                    path: path
                                });
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var SmallDropDownMenu_WorksMenu = (WorksMenu);

// EXTERNAL MODULE: ./UI/sections/Header/SmallDropDownMenu/CompanyMenu/styles.module.scss
var CompanyMenu_styles_module = __webpack_require__(52104);
var CompanyMenu_styles_module_default = /*#__PURE__*/__webpack_require__.n(CompanyMenu_styles_module);
;// CONCATENATED MODULE: ./UI/sections/Header/SmallDropDownMenu/CompanyMenu/index.jsx








var CompanyMenu = function(param) {
    var isLightTheme = param.isLightTheme, isPageScrolledDown = param.isPageScrolledDown;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((CompanyMenu_styles_module_default()).dropdownContainer, (0,_define_property/* default */.Z)({}, (CompanyMenu_styles_module_default()).light, isLightTheme || isPageScrolledDown)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CompanyMenu_styles_module_default()).contentContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (CompanyMenu_styles_module_default()).leftContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: (CompanyMenu_styles_module_default()).serviceTitle,
                            children: [
                                "Measurable success powered by",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "AI innovation"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Our Clients"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CompanyMenu_styles_module_default()).clientsList,
                            children: headerConstants/* CLIENTS_LIST.map */.jV.map(function(param) {
                                var icon = param.icon, path = param.path, title = param.title;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                                    path: path,
                                    className: (CompanyMenu_styles_module_default()).clientImage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (CompanyMenu_styles_module_default()).clientContainer,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (CompanyMenu_styles_module_default()).clientIconContainer,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg["default"], {
                                                    type: icon
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: title
                                            })
                                        ]
                                    })
                                });
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CompanyMenu_styles_module_default()).ourWorkContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Yellow in Numbers"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CompanyMenu_styles_module_default()).yellowNumbers,
                                children: headerConstants/* YELLOW_NUMBERS.map */.vF.map(function(param) {
                                    var title = param.title, description = param.description;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: description
                                            })
                                        ]
                                    });
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Navigation"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: headerConstants/* NAVIGATION.map */.k2.map(function(param) {
                                    var title = param.title, description = param.description, path = param.path;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                        title: title,
                                        description: description,
                                        path: path
                                    });
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SmallDropDownMenu_CompanyMenu = (CompanyMenu);

;// CONCATENATED MODULE: ./UI/sections/Header/SmallDropDownMenu/utils/dropDownConstants.jsx






var _obj;
var DROPDOWN_CONTENT = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* INTERACTIVE_LINKS.company.slug */.RG.company.slug, SmallDropDownMenu_CompanyMenu), (0,_define_property/* default */.Z)(_obj, constants/* INTERACTIVE_LINKS.services.slug */.RG.services.slug, SmallDropDownMenu_ServiceMenu), (0,_define_property/* default */.Z)(_obj, constants/* INTERACTIVE_LINKS.aiTransformation.slug */.RG.aiTransformation.slug, SmallDropDownMenu_AITransformationMenu), (0,_define_property/* default */.Z)(_obj, constants/* INTERACTIVE_LINKS.works.slug */.RG.works.slug, SmallDropDownMenu_WorksMenu), _obj);

;// CONCATENATED MODULE: ./UI/sections/Header/SmallDropDownMenu/utils/useSmallDropDownMenu.js

var useSmallDropDownMenu = function(param) {
    var slug = param.slug, isPageScrolledDown = param.isPageScrolledDown, isDropMenuOpened = param.isDropMenuOpened, closeDropDownMenu = param.closeDropDownMenu, selected = param.selected, theme = param.theme, disableAnimation = param.disableAnimation;
    var SubNavigationLinks = slug ? DROPDOWN_CONTENT[slug] : null;
    var handleOnLinkClick = function(subMenuLinkSlug) {
        return function() {
            if (subMenuLinkSlug) {
                closeDropDownMenu();
            }
        };
    };
    return {
        slug: slug,
        isPageScrolledDown: isPageScrolledDown,
        isDropMenuOpened: isDropMenuOpened,
        SubNavigationLinks: SubNavigationLinks,
        handleOnLinkClick: handleOnLinkClick,
        selected: selected,
        theme: theme,
        disableAnimation: disableAnimation
    };
};

// EXTERNAL MODULE: ./UI/sections/Header/SmallDropDownMenu/styles.module.scss
var SmallDropDownMenu_styles_module = __webpack_require__(56425);
var SmallDropDownMenu_styles_module_default = /*#__PURE__*/__webpack_require__.n(SmallDropDownMenu_styles_module);
;// CONCATENATED MODULE: ./UI/sections/Header/SmallDropDownMenu/index.jsx









var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var SmallDropDownMenu = function(props) {
    var ref = useSmallDropDownMenu(props), slug = ref.slug, selected = ref.selected, isPageScrolledDown = ref.isPageScrolledDown, isDropMenuOpened = ref.isDropMenuOpened, SubNavigationLinks = ref.SubNavigationLinks, handleOnLinkClick = ref.handleOnLinkClick, theme = ref.theme, disableAnimation = ref.disableAnimation;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((SmallDropDownMenu_styles_module_default()).smallDropDownMenu, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (SmallDropDownMenu_styles_module_default()).lightTheme, theme === "light"), (0,_define_property/* default */.Z)(_obj, (SmallDropDownMenu_styles_module_default()).pageScrolling, isPageScrolledDown), (0,_define_property/* default */.Z)(_obj, (SmallDropDownMenu_styles_module_default()).closed, !(selected === slug)), (0,_define_property/* default */.Z)(_obj, (SmallDropDownMenu_styles_module_default()).noAnimation, disableAnimation), _obj)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((SmallDropDownMenu_styles_module_default()).container),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNavigationLinks, {
                isLightTheme: theme === "light",
                isPageScrolledDown: isPageScrolledDown,
                handleOnLinkClick: handleOnLinkClick
            })
        })
    });
};
SmallDropDownMenu.propTypes = {
    slug: (prop_types_default()).string.isRequired,
    isLightTheme: (prop_types_default()).bool,
    isPageScrolledDown: (prop_types_default()).bool.isRequired,
    isDropMenuOpened: (prop_types_default()).bool.isRequired,
    closeDropDownMenu: (prop_types_default()).func,
    disableAnimation: (prop_types_default()).bool
};
/* harmony default export */ var Header_SmallDropDownMenu = (SmallDropDownMenu);


/***/ }),

/***/ 75456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AU": function() { return /* binding */ SERVICES; },
/* harmony export */   "FV": function() { return /* binding */ TEAM; },
/* harmony export */   "Fw": function() { return /* binding */ PROJECTS; },
/* harmony export */   "hO": function() { return /* binding */ MOBILE_MENU; },
/* harmony export */   "jV": function() { return /* binding */ CLIENTS_LIST; },
/* harmony export */   "k2": function() { return /* binding */ NAVIGATION; },
/* harmony export */   "oj": function() { return /* binding */ SERVICES_FULL; },
/* harmony export */   "r_": function() { return /* binding */ FEATURED_CASES_PREVIEWS; },
/* harmony export */   "vF": function() { return /* binding */ YELLOW_NUMBERS; },
/* harmony export */   "y": function() { return /* binding */ TECH_STACK; },
/* harmony export */   "z2": function() { return /* binding */ FEATURED_CASES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96076);
/* harmony import */ var utils_routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27727);




var TEAM = [
    {
        name: "Dmitry",
        image: "https://images.ctfassets.net/ic8vz4cuikua/4AlGEoLzj3iF5AuFNiBHS9/2abfed64e6fd991ef02f49aa4714f8b9/Dzimitry-Babrou.jpg",
        path: "/person/dmitry"
    },
    {
        name: "Sofia",
        image: "https://images.ctfassets.net/ic8vz4cuikua/5IMwm9ytTZlJnlQ45btYQ6/1ae488d79c723a25f15c871231707f64/fdba7a3d3f83799e1087b672361f5a2bc68a78b6.png",
        path: "/person/sofia"
    },
    {
        name: "Mikita",
        image: "https://images.ctfassets.net/ic8vz4cuikua/7m4Z4lptksMscgP6RoyKza/2ca912125e97cba134acf8eb6d026625/mikita.jpg",
        path: "/person/mikita"
    },
    {
        name: "Vlad",
        image: "https://images.ctfassets.net/ic8vz4cuikua/47k219ZNgOacNZPTFimBGx/7222776055f9869f27470fb76c4931dc/e46eb7a38772c7cd4d56104c5f1899fffd677002.png",
        path: "/person/vlad"
    }, 
];
var TECH_STACK = [
    "pythonColor",
    "jsColor",
    "tensorflowColor",
    "pytorchColor",
    "claudeColor",
    "spaCyColor",
    "ocrColor",
    "langGraphColor",
    "reactColor",
    "nodeColor", 
];
var CLIENTS_LIST = [
    {
        path: "https://writer.com/",
        icon: "writerColor",
        title: "Writer"
    },
    {
        path: "https://www.netflix.com/",
        icon: "netflixColor",
        title: "Netflix"
    },
    {
        path: "https://www.mcdonalds.com",
        icon: "mcDonaldsColor",
        title: "MCD"
    },
    {
        path: "https://www.allianz.com/en.html",
        icon: "allianzColor",
        title: "Allianz"
    }, 
];
var YELLOW_NUMBERS = [
    {
        title: "$2.1B+",
        description: "Value generated through AI innovation"
    },
    {
        title: "47",
        description: "Custom LLMs and AI agents deployed"
    },
    {
        title: "30M+",
        description: "Engaging with products we created"
    },
    {
        title: "98%",
        description: "Projects delivered within agreed budget"
    }, 
];
var SERVICES = [
    {
        icon: "generativeAi",
        title: "Generative AI",
        path: utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .routes.generativeAiDevelopment.path */ ._.generativeAiDevelopment.path
    },
    {
        icon: "llmDev",
        title: "LLM",
        path: utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .routes.llmDevelopment.path */ ._.llmDevelopment.path
    },
    {
        icon: "aiAgent",
        title: "AI Agents",
        path: utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .routes.aiAgentsServices.path */ ._.aiAgentsServices.path
    },
    {
        icon: "rag",
        title: "RAG",
        path: utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .routes.ragDevelopment.path */ ._.ragDevelopment.path
    },
    {
        icon: "computerVision",
        title: "Computer Vision",
        path: utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .routes.computerVisionServices.path */ ._.computerVisionServices.path
    }, 
];
var NAVIGATION = [
    {
        title: "About us",
        description: "Who we are and our mission in the AI landscape.",
        path: utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .routes.company.path */ ._.company.path
    },
    {
        title: "Why us",
        description: "Our competitive edge and technical expertise.",
        path: utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .routes.whyUs.path */ ._.whyUs.path
    },
    {
        title: "Blog",
        description: "Insights on the latest AI trends and practical use cases.",
        path: utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .routes.blog.path */ ._.blog.path
    }, 
];
var SERVICES_FULL = [
    {
        icon: "aiDev",
        title: "AI Development",
        path: utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .routes.aiDevelopment.path */ ._.aiDevelopment.path
    },
    {
        icon: "monitor01",
        title: "Software Engineering",
        path: utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .routes.customWebApp.path */ ._.customWebApp.path
    },
    {
        icon: "penTool",
        title: "UI/UX Design",
        path: utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .routes.designServices.path */ ._.designServices.path
    },
    {
        icon: "test",
        title: "QA",
        path: utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .routes.softwareQualityAssuranceServices.path */ ._.softwareQualityAssuranceServices.path
    },
    {
        icon: "database",
        title: "DevOps",
        path: utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .routes.devOpsDevelopment.path */ ._.devOpsDevelopment.path
    }, 
];
var FEATURED_CASES_PREVIEWS = [
    {
        name: "Writer Framework Platform",
        image: "https://images.ctfassets.net/ic8vz4cuikua/6d2Af7ssqcDS25QigSS4XE/8db821387e8d7d4ac178f9886caac3c3/Image__22_.png",
        path: "/works/writer-framework-platform"
    },
    {
        name: "Predictive Lead Scoring with AI",
        image: "https://images.ctfassets.net/ic8vz4cuikua/YZ1RovcSrMqDjMtoChUr4/91c079b7b5c384a09e06aa7dca21c60f/Image__18_.png",
        path: "/works/predictive-ai-for-marketing"
    },
    {
        name: "AML Detection Tool",
        image: "https://images.ctfassets.net/ic8vz4cuikua/3dvGVPSE65lHxsYDchTicM/3805ef750c52b88297831687ce8c5bee/Image__19_.png",
        path: "/works/enhancing-money-laundering-mention-extraction"
    },
    {
        name: "AI Concierge Agent",
        image: "https://images.ctfassets.net/ic8vz4cuikua/7kioBcRy5uzIa66gvGNSDk/2c96478ea4d2b459e9af985440d84582/Image__20_.png",
        path: "/works/ai-concierge-for-hotel-network"
    }, 
];
var FEATURED_CASES = [
    {
        title: "AI Framework for Writer",
        path: "/works/writer-framework-platform"
    },
    {
        title: "AI Tool for Process Optimization",
        path: "/works/ai-documentation-processing"
    },
    {
        title: "HR AI Agent",
        path: "/works/ai-agent-for-pre-screening"
    },
    {
        title: "Hotel Booking AI Agent",
        path: "/works/ai-concierge-for-hotel-network"
    },
    {
        title: "AI Voice Agent for e-Learning",
        path: "/works/ai-voice-assistant-for-e-learning"
    },
    {
        title: "Computer vision for ARAS",
        path: "/works/computer-vision-for-aras"
    }, 
];
var PROJECTS = [
    {
        title: "AI Learning Personalization",
        description: "Smart content recommendations",
        path: "/works/ai-for-edtech"
    },
    {
        title: "Hotel AI Concierge",
        description: "AI assistant for hotel guests",
        path: "/works/ai-concierge-for-hotel-network"
    },
    {
        title: "Claims Documentation Automation",
        description: "Platform for faster claims processing",
        path: "/works/llm-for-insurtech-saas"
    },
    {
        title: "AI for Candidate Screening",
        description: "Smart HR efficiency booster",
        path: "/works/ai-agent-for-pre-screening"
    },
    {
        title: "AI Voice Agent",
        description: "AI agent for hands-free learning",
        path: "/works/ai-voice-assistant-for-e-learning"
    },
    {
        title: "LLM Legal Summarization",
        description: "Efficient and fast legal summaries",
        path: "/works/llm-legal-document-summarization"
    },
    {
        title: "Vision-Based Driving Assistance",
        description: "Real-time threat detection system",
        path: "/works/computer-vision-for-aras"
    }, 
];
var MOBILE_MENU = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .INTERACTIVE_LINKS.company.slug */ .RG.company.slug, [
    {
        title: "Navigation",
        items: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(NAVIGATION)
    }, 
]);


/***/ }),

/***/ 55098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"styles_dropdownContainer__xvYWg","contentContainer":"styles_contentContainer__YgO2e","leftContent":"styles_leftContent__FcmjL","teamList":"styles_teamList__8_pvk","memberContainer":"styles_memberContainer__hdWz1","personImageContainer":"styles_personImageContainer__nRlSx","memberImage":"styles_memberImage__jFKQK","techList":"styles_techList__aSFPn","techImage":"styles_techImage__llbuc","ourWorkContent":"styles_ourWorkContent__xWKkK","clientsList":"styles_clientsList__0lDfL","clientImage":"styles_clientImage__G_Lip","clientContainer":"styles_clientContainer__7UVfu","clientIconContainer":"styles_clientIconContainer__ksQc8","linksContainer":"styles_linksContainer__739XG","light":"styles_light__kT_8t"};

/***/ }),

/***/ 52104:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"styles_dropdownContainer__CkfEh","contentContainer":"styles_contentContainer__fC95T","leftContent":"styles_leftContent__Pq93n","serviceTitle":"styles_serviceTitle__B_jj8","clientsList":"styles_clientsList__VpHKS","clientImage":"styles_clientImage__NTDHb","clientContainer":"styles_clientContainer__eOOna","clientIconContainer":"styles_clientIconContainer__OiB5O","ourWorkContent":"styles_ourWorkContent__sWzBa","yellowNumbers":"styles_yellowNumbers__A8mCS","light":"styles_light__XgMtA"};

/***/ }),

/***/ 56060:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navItem":"styles_navItem__MQxe7","title":"styles_title__VtTfN","description":"styles_description__ti58Y"};

/***/ }),

/***/ 75754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"styles_dropdownContainer__ViIHL","contentContainer":"styles_contentContainer__5bXw6","leftContent":"styles_leftContent__uvE3_","serviceTitle":"styles_serviceTitle__oP310","clutchContainer":"styles_clutchContainer__OLw2s","seeAllButton":"styles_seeAllButton__VrZuR","ourWorkContent":"styles_ourWorkContent__dlKBE","linksContainer":"styles_linksContainer__0kG6w","light":"styles_light__Te5dZ"};

/***/ }),

/***/ 42991:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"styles_dropdownContainer__5m6t6","contentContainer":"styles_contentContainer__FwklW","leftContent":"styles_leftContent__6_4sH","teamList":"styles_teamList__501bW","projectLink":"styles_projectLink__zQfTn","imageContainer":"styles_imageContainer__hSLOV","memberContainer":"styles_memberContainer__hkMfo","memberImage":"styles_memberImage__KUf5O","ourWorkContent":"styles_ourWorkContent__w4A7Z","clientsList":"styles_clientsList__Ey_sW","clientImage":"styles_clientImage__7zcnp","light":"styles_light__WoYn4","seeAllButton":"styles_seeAllButton__uoA5y"};

/***/ }),

/***/ 56425:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"smallDropDownMenu":"styles_smallDropDownMenu__9gvhp","container":"styles_container__hrmu_","pageScrolling":"styles_pageScrolling__f2MNC","lightTheme":"styles_lightTheme__mdUEi","closed":"styles_closed__IqQ43","noAnimation":"styles_noAnimation__F0Afk"};

/***/ })

}]);